class ServiceWorkerProxy {
  constructor() {
    this.isRegistered = false;
    this.registration = null;
  }

  async register() {
    if (!('serviceWorker' in navigator)) {
      console.warn('Service Worker não é suportado neste navegador');
      return false;
    }

    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      console.warn('Service Worker só funciona em HTTPS ou localhost');
      return false;
    }

    try {
      console.log('Registrando Service Worker para proxy...');
      
      this.registration = await navigator.serviceWorker.register('/sw-proxy.js', {
        scope: '/'
      });

      console.log('Service Worker registrado com sucesso:', this.registration);

      this.registration.addEventListener('updatefound', () => {
        const newWorker = this.registration.installing;
        console.log('Nova versão do Service Worker encontrada');
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('Nova versão do Service Worker instalada');
            this.notifyUpdate();
          }
        });
      });

      await this.waitForServiceWorker();
      this.isRegistered = true;
      return true;
    } catch (error) {
      console.error('Erro ao registrar Service Worker:', error);
      return false;
    }
  }

  async waitForServiceWorker() {
    return new Promise((resolve) => {
      if (navigator.serviceWorker.controller) {
        resolve();
        return;
      }

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        resolve();
      });
    });
  }

  notifyUpdate() {
    if (this.registration && this.registration.waiting) {
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }

  async unregister() {
    if (this.registration) {
      try {
        await this.registration.unregister();
        console.log('Service Worker removido com sucesso');
        this.isRegistered = false;
        return true;
      } catch (error) {
        console.error('Erro ao remover Service Worker:', error);
        return false;
      }
    }
    return true;
  }

  isSupported() {
    return 'serviceWorker' in navigator;
  }

  isHttpsRequired() {
    return window.location.protocol === 'https:';
  }

  shouldUseServiceWorkerProxy() {
    return this.isSupported() && this.isHttpsRequired() && this.isRegistered;
  }
}

const serviceWorkerProxy = new ServiceWorkerProxy();
export default serviceWorkerProxy; 